import { map, prop, values } from 'ramda'

import type { VendingExternalServiceType } from 'app/dataTypes/vending/externalServices'

import type { Request } from '../../../index'


type ExternalServiceApi = {
  id: number
  title: string
  active: boolean
}

type ApiResult = {
  result: 'success'
  meta: {}
  data: {
    [serviceId in string]: ExternalServiceApi
  }
}


export const convertResult = (data: ApiResult): Array<VendingExternalServiceType> => {
  const items = prop('data', data) || {}
  return map(({ id, title, active }) => ({
    serviceId: id.toString(),
    title,
    active
  }), values(items))
}

export const GET_VENDING_EXTERNAL_SERVICES: Request<void, Array<VendingExternalServiceType>, void> = [
  'data/vending/external_services',
  'get',
  ['data'],
]
